import { useEffect } from "react";
import api from "@/lib/api";

let injected = false;

function setMeta(name, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function injectGTM(id) {
  if (!id || document.getElementById("wb-gtm-script")) return;
  if (!/^GTM-[A-Za-z0-9]{4,15}$/.test(id.trim())) return;
  const s = document.createElement("script");
  s.id = "wb-gtm-script";
  s.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');`;
  document.head.appendChild(s);
}

/**
 * Runs once on app mount — fetches settings and injects:
 *  - Search-engine verification meta tags (Google, Bing, Facebook, Pinterest, Yandex)
 *  - Google Tag Manager script (if ID set)
 */
export function useSiteVerifications() {
  useEffect(() => {
    if (injected) return;
    injected = true;
    api
      .get("/settings")
      .then((r) => {
        const s = r.data || {};
        setMeta("google-site-verification", s.google_site_verification);
        setMeta("msvalidate.01", s.bing_site_verification);
        setMeta("facebook-domain-verification", s.facebook_domain_verification);
        setMeta("p:domain_verify", s.pinterest_verification);
        setMeta("yandex-verification", s.yandex_verification);
        injectGTM(s.google_tag_manager_id);
      })
      .catch(() => {});
  }, []);
}
